import { Helmet } from "react-helmet-async";
import TermsOfConditionsView from "src/sections/terms-of-conditions/view";

export default function TermsOfConditionsPage() {
    return (
        <>
            <Helmet>
                <title> Terms and Conditions | SiteSnap Admin</title>
            </Helmet>
            <TermsOfConditionsView />
        </>
    );
}
